export default "__VITE_ASSET__49296000__"